module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "prop": _vm.prop,
      "required": _vm.required
    }
  }, [(!_vm.disabled) ? _c('el-input-number', {
    attrs: {
      "step": _vm.step,
      "min": _vm.min,
      "max": _vm.max,
      "size": _vm.size,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }) : _c('span', [(_vm.prefix) ? _c('span', [(_vm.isPrefixIcon) ? _c('i', {
    class: _vm.prefix
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prefix)
    }
  })]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(this.formatNumber(this.formData, this.decimals)))]), _vm._v(" "), (_vm.suffix) ? _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [(_vm.isSuffixIcon) ? _c('i', {
    class: _vm.suffix
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.suffix)
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc69ffd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/NumberInput.vue
// module id = 1543
// module chunks = 0